




















































import { Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { AgencyModule } from '@/store/modules/agency';
import { AgencyDashboardModule } from '@/store/modules/agencyDashboard';
import { CompanyDetailsModule } from '@/store/modules/companyDetails';
import { CompanyListModule } from '@/store/modules/companyList';
import { ContactDetailsModule } from '@/store/modules/contactDetails';
import { ContactListModule } from '@/store/modules/contactList';
import { WorkerAnonModule } from '@/store/modules/workerAnon';
import { WorkerWizardModule } from '@/store/modules/workerWizard';
import { WorkerDetailsModule } from '@/store/modules/workerDetails';
import { WorkerListModule } from '@/store/modules/workerList';
import { LocationDetailsModule } from '@/store/modules/locationDetails';
import { LocationListModule } from '@/store/modules/locationList';
import { BookingDetailsModule } from '@/store/modules/bookingDetails';
import { BookingListModule } from '@/store/modules/bookingList';
import { BookingWizardModule } from '@/store/modules/bookingWizard';
import { ReportsModule } from '@/store/modules/reports';
import UserProfileDto from '@/models/Users/UserProfileDto';
import PageNames from '@/router/PageNames';

@Component({
  name: 'UserProfileMenu',
  components: {  }
})
export default class extends Vue {

  menu = false;

  get userProfile() {
    return AppModule.userProfile;
  }

  get userAvatarUrl(): string {
    if (!this.userProfile?.avatar) {
      return '';
    }
    if (!this.userProfile?.agencyUserId) {
      return '';
    }
    if (!AppModule.currentAgencyContext?.storageSharedBaseUrl) {
      return '';
    }
    return AppModule.currentAgencyContext.storageSharedBaseUrl +
      '/avatars/2/' + this.userProfile.agencyUserId +
      '/resized-100/' + this.userProfile.avatar;
  }

  goToSettings() {
    this.$router.push({ name: PageNames.AgencyUserProfile });
  }

  async logOut() {
    await AppModule.firebaseLogOut();
    this.$router.push({ name: PageNames.Login });
  }

}
